import React from "react";
import Layout from "../layout/adminExt/Layout";
import Overview from "./overview/Overview";

export default function Index() {
  return (
    <Layout>
      <Overview />
    </Layout>
  );
}
